module.exports = __webpack_public_path__ + "img/abgc8.90bf8ad2.jpg";